import React, { useRef, useState } from 'react';
import RequestAdminLocalPW from 'widgets/RequestAdminLocalPW';
import ticketListActions from 'features/ticketList/services/actions';
import { useAppDispatch } from 'store/hooks';
import { IStaffItemData } from 'services/shop/types/staff';
import { FeaturePermission } from 'constants/Permission';
import UnrevokedNoteModal, { UnrevokedNoteRef } from './UnrevokedNoteModal';
import Button from 'components/Button';
import styled from 'styled-components';
import IcUnrevorked from 'assets/Icons/IcUnrevorked';
import ticketListSelectors from 'features/ticketList/services/selectors';

interface IUnrevokedButtonProps {
  selectedRowKeys: string[];
  onSuccess: () => void;
}

const UnrevokedButton = ({ selectedRowKeys, onSuccess }: IUnrevokedButtonProps) => {
  const [visiblePW, setVisiblePW] = useState(false);
  const dispatch = useAppDispatch();
  const unrevokedNoteModal = useRef<UnrevokedNoteRef>(null);
  const showRequestAdminLocalPW = () => {
    setVisiblePW(true);
  };

  const onUnrevokedTicketSuccess = () => {
    dispatch(ticketListActions.afterDeleteClosedTicket());
    onSuccess();
  };

  const onVerifyAdminSuccess = (pin?: string, staffDataVerified?: IStaffItemData) => {
    setVisiblePW(false);
    const billIds = selectedRowKeys;
    const data = {
      billIds: billIds,
      staffId: staffDataVerified?.id || '',
    };
    unrevokedNoteModal.current?.open(data, onUnrevokedTicketSuccess);
  };

  return (
    <Container>
      <Button
        ntype='ORANGE_V2'
        onClick={showRequestAdminLocalPW}
        cardCashier
        height={3}
        iconElement={<IcUnrevorked fill='#FFF' />}
        disabled={selectedRowKeys.length === 0}
      >
        Unrevoked
      </Button>
      {visiblePW && (
        <RequestAdminLocalPW
          onlyAdmin
          visible
          v2={true}
          onCorrect={onVerifyAdminSuccess}
          onClose={() => setVisiblePW(false)}
          featureCode={FeaturePermission.DELETE_TICKET}
        />
      )}
      <UnrevokedNoteModal ref={unrevokedNoteModal} />
    </Container>
  );
};

export default UnrevokedButton;

const Container = styled.div`
  .CONTENT_2 {
    font-size: 22px;
    line-height: 1;
  }
`;
